import React from 'react';

import classes from './CurrentPlanWidget.module.scss';
import { InfoBox } from '../../../../../../../../shared/components/ui-components';
import {
  BillingPeriodType,
  BillingPeriodTypeChip,
} from '../../../../../../../../payment';

type CurrentPlanWidgetProps = {
  subscriptionName: string;
  billingPeriodType: BillingPeriodType;
};

const CurrentPlanWidget = ({
  subscriptionName,
  billingPeriodType,
}: CurrentPlanWidgetProps) => {
  return (
    <InfoBox title="Current Active Plan" customMargin>
      <p className={classes.title}>{subscriptionName}</p>
      <BillingPeriodTypeChip billingPeriodType={billingPeriodType} />
    </InfoBox>
  );
};

export { CurrentPlanWidget };
